import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FlashAlert } from "./flashAlert";

const ModalFlashMessage = ({ flashMessage }) => {
  const [flash, setflash] = useState({});
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const allStates = useSelector(state => state);

  const toggleFlash = () => setVisible(!visible);
  const exceptions = [];

  const handleChange = state => {
    let isflashMessage = Object.keys(state).some(reducer => state[reducer].flashMessage);
    let isStatusInvalid = Object.keys(state).some(
      reducer => state[reducer].status === 401 && !exceptions.includes(state[reducer].type)
    );
    if (isStatusInvalid) {
      setTimeout(() => {
        dispatch(logout());
        dispatch(clearCurrentUserSession());
      }, 300);
    }
    if (isflashMessage && !isStatusInvalid) {
      let reducer = Object.keys(state).find(reducer => state[reducer].flashMessage);
      setflash(state[reducer].flashMessage);
      setVisible(true);
    }
  };

  useEffect(() => {
    handleChange(allStates);
  }, [allStates]);

  useEffect(() => {
    if (flashMessage) {
      setflash(flashMessage);
      setVisible(true);
    }
  }, [flashMessage]);

  return (
    <FlashAlert
      isOpen={visible}
      toggle={toggleFlash}
      type={flash.type}
      message={flash.message}
      component={flash.component}
    />
  );
};

export default ModalFlashMessage;
